<template>
  <div class="detailBox">
    <ul class="detailContent">
      <el-form
        :model="state.model"
        label-width="100px"
        :scroll-to-error="true"
        ref="formDom"
        inline
        style="position: relative"
      >
        <!-- 同行客户选择框 -->
        <el-form-item label="客户" prop="TongHangKhId" style="width: 70%">
          <el-select
            v-model="state.model.TongHangKhId"
            placeholder="--请选择同行客户--"
            filterable
            :filter-method="onTongHangKhFilter"
            :loading="state.tongHangKhLoading"
            style="width: 100%"
          >
            <el-option
              v-for="item in state.tongHangKhData"
              :key="item.Id"
              :label="item.Mc"
              :value="item.Id"
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                "
              >
                <span>{{ item.Mc }}</span>
                <span v-if="item.Sjhm" style="color: #999; font-size: 12px">{{
                  item.Sjhm
                }}</span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onCreateShareCode()"
            >生成小程序码</el-button
          >
        </el-form-item>
      </el-form>

      <!-- 小程序码显示区域 -->
      <div v-if="state.qrCodeUrl" class="qr-code-container">
        <div class="qr-code-wrapper">
          <div class="qr-tip">
            <text>游客扫描此小程序码进入后，24小时内下单将关联到该客户</text>
          </div>
          <img
            :src="state.qrCodeUrl"
            alt="小程序码"
            class="qr-code-image"
          />
          <div class="qr-code-actions">
            <el-button type="primary" @click="downloadQRCode">
              <el-icon><Download /></el-icon>
              下载小程序码
            </el-button>
          </div>
        </div>
      </div>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { ElMessage } from "element-plus";
import { Download } from "@element-plus/icons-vue";
import { kehu_list, share_wxacode } from "@/http/api";

export default {
  components: {
    Download,
  },
  props: {
    id: Number,
  },
  setup(props) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        TongHangKhId: null,
      },
      tongHangKhData: [],
      tongHangKhSource: [],
      tongHangKhLoading: false,
      qrCodeUrl: "", // 小程序码图片URL（base64）
    });
    onMounted(() => {
      loadTongHangKh();
    });

    // 加载同行客户数据
    const loadTongHangKh = () => {
      state.tongHangKhLoading = true;
      kehu_list({ PageSize: 1000, PageIndex: 1 })
        .then((res) => {
          const flattenData = flattenTreeDataku(res.data);
          state.tongHangKhData = flattenData;
          state.tongHangKhSource = flattenData;
          state.tongHangKhLoading = false;
        })
        .catch(() => {
          state.tongHangKhLoading = false;
        });
    };

    // 将树形数据扁平化
    const flattenTreeDataku = (treeData) => {
      const result = [];
      treeData.list.forEach((node) => {
        result.push({
          Id: node.Id,
          Mc: `${node.Lxr} (${node.Sjhm || ""})`,
          Sjhm: node.Sjhm || "",
          BmMc: node.Mc || "",
          Zw: node.Zw || "",
        });
      });
      return result;
    };

    // 同行客户下拉框筛选方法
    const onTongHangKhFilter = (query) => {
      if (!query) {
        state.tongHangKhData = state.tongHangKhSource;
        return;
      }
      state.tongHangKhData = state.tongHangKhSource.filter(
        (item) =>
          item.Mc?.toLowerCase().includes(query.toLowerCase()) ||
          item.Sjhm?.includes(query) ||
          item.BmMc?.toLowerCase().includes(query.toLowerCase()) ||
          item.Zw?.toLowerCase().includes(query.toLowerCase())
      );
    };

    // ===== 旧逻辑（生成H5二维码）已注释，改为生成微信小程序码 =====
    // const onCreateShareCode = async () => {
    //   const id = state.model.TongHangKhId;
    //   const phone = state.tongHangKhData
    //     .filter((t) => t.Id == id)
    //     .map((t) => t.Phone)[0];
    //   ...
    //   const qrCodeDataUrl = await QRCode.toDataURL(state.shareUrl, {...});
    //   state.qrCodeUrl = qrCodeDataUrl;
    // };

    // 生成微信小程序码（场景B：scene=客户Id，游客扫码后关联该客户）
    const onCreateShareCode = async () => {
      const khId = state.model.TongHangKhId;
      if (!khId) {
        ElMessage({ message: "请选择客户", type: "error" });
        return;
      }

      try {
        const res = await share_wxacode(khId);
        if (res.status == 200 && res.data?.image) {
          state.qrCodeUrl = res.data.image;
          ElMessage({ message: "小程序码生成成功", type: "success" });
        } else {
          ElMessage({
            message: res.data?.message || res.data || "生成失败",
            type: "error",
          });
        }
      } catch (error) {
        console.error("生成小程序码失败:", error);
        ElMessage({ message: "生成小程序码失败", type: "error" });
      }
    };

    // 下载小程序码
    const downloadQRCode = () => {
      if (!state.qrCodeUrl) {
        ElMessage({ message: "请先生成小程序码", type: "warning" });
        return;
      }
      try {
        const link = document.createElement("a");
        link.href = state.qrCodeUrl;
        link.download = `小程序码_${state.model.TongHangKhId}_${new Date().getTime()}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        ElMessage({ message: "下载成功", type: "success" });
      } catch (error) {
        console.error("下载失败:", error);
        ElMessage({ message: "下载失败", type: "error" });
      }
    };

    return {
      state,
      formDom,
      props,
      onTongHangKhFilter,
      onCreateShareCode,
      downloadQRCode,
    };
  },
};
</script>
<style scoped>
.qr-code-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.qr-code-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.qr-tip {
  text-align: center;
  font-size: 13px;
  color: #909399;
  max-width: 320px;
}

.qr-code-image {
  width: 300px;
  height: 300px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.qr-code-actions {
  display: flex;
  gap: 10px;
}
</style>
